/**
 * PLP card color swatches: hover to select (legacy-theme behaviour).
 *
 * Hovering a swatch selects that colour on the product card (like the old theme): it checks the
 * swatch's radio (so the selected ring shows) and swaps the card's primary image to that variant's
 * image, read from the swatch input's `data-variant-media`. Delegated on `document` so it also
 * covers cards injected later (filtering, pagination, quick-buy).
 */
(() => {
  const SWATCH_SELECTOR = '.product-card__info .color-swatch';
  const IMAGE_WIDTH = 500;

  const swapCardImage = (card, media) => {
    const primary = card.querySelector('.product-card__image--primary');
    const preview = media && media.preview_image;
    if (!primary || primary.tagName !== 'IMG' || !preview || !preview.src) return;

    const base = preview.src.indexOf('//') === 0 ? `https:${preview.src}` : preview.src;
    let href;
    try {
      const url = new URL(base);
      url.searchParams.set('width', IMAGE_WIDTH);
      href = url.href;
    } catch (_) {
      href = base;
    }

    if (primary.src === href) return;
    primary.srcset = '';
    primary.src = href;
  };

  document.addEventListener(
    'mouseover',
    (event) => {
      const label = event.target.closest(SWATCH_SELECTOR);
      if (!label) return;

      const input = label.control;
      if (!input || input.disabled) return;

      // Reflect the selection (checked ring) even though no click happened.
      if (!input.checked) input.checked = true;

      const card = label.closest('product-card') || label.closest('.product-card');
      if (!card) return;

      const raw = input.getAttribute('data-variant-media');
      if (!raw) return;

      let media;
      try {
        media = JSON.parse(raw);
      } catch (_) {
        return;
      }

      swapCardImage(card, media);
    },
    { passive: true }
  );
})();
